import Utils from "../utils/utils";
import Bridge, { BridgeMessage } from "./bridge";
import { BridgeMessageTypeVibrate } from "./bridge.types";

export default class BridgeVibrate extends Bridge {
  constructor() {
    super();
  }
    
  public async vibrateAsync(pattern: number | number[]): Promise<boolean> {
    if (!Array.isArray(pattern)) {
      pattern = [pattern];
    }
    return new Promise((resolve, reject) => {
      const message: BridgeMessage = {
        uuid: Utils.UUID(),
        type: BridgeMessageTypeVibrate,
        data: { pattern: Array.from(pattern) },
      };
      this.send(message, resolve, reject);
    });
  }
}